import { getApi } from "./api_instance";

export const getBuyerTransactionCommunication = async (transactionId, dispatch) => {
  try {
    return await getApi({
      apiUrl: `/payments/api/transactions/communication/buyer/${transactionId}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
}